import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Button } from './ui/button';
import { CheckCircle2, ArrowRight } from 'lucide-react';

const benefits = [
  'Controle total das suas finanças',
  'Organização do fluxo de caixa',
  'Decisões financeiras mais inteligentes',
  'Redução de desperdícios invisíveis',
  'Mais previsibilidade e estabilidade',
  'Clareza sobre para onde seu dinheiro está indo'
];

export const BenefitsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });

  const handleCTAClick = () => {
    window.open('https://pay.monetizze.com.br/KRA456690', '_blank');
  };

  return (
    <section ref={ref} className="py-20 sm:py-32 relative overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-card/20 to-background" />
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Section Title */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
              O que você{' '}
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary">
                conquista
              </span>
              {' '}com o FinanceAI
            </h2>
            <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed">
              Transforme sua relação com o dinheiro e alcance seus objetivos financeiros
            </p>
          </motion.div>

          {/* Benefits List */}
          <div className="space-y-4 mb-12">
            {benefits.map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -30 }}
                animate={isInView ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
                className="group"
              >
                <div className="bg-card/50 backdrop-blur-sm border border-border/50 rounded-xl p-6 hover:border-primary/30 hover:bg-card/70 transition-all duration-300 hover:shadow-lg hover:shadow-primary/10">
                  <div className="flex items-center gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                        <CheckCircle2 className="w-6 h-6 text-primary" />
                      </div>
                    </div>
                    <p className="text-lg font-medium text-foreground">
                      {benefit}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {/* CTA */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.9 }}
            className="text-center"
          >
            <Button
              onClick={handleCTAClick}
              size="lg"
              className="group relative overflow-hidden bg-primary hover:bg-primary-glow text-primary-foreground px-12 py-6 text-lg font-semibold rounded-xl shadow-glow hover:shadow-glow-strong transition-all duration-300 hover:scale-105"
            >
              <span className="relative z-10 flex items-center gap-2">
                EU QUERO
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-primary-glow to-secondary opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
